import { GenerateFields } from '@components/common/Forms/GenerateFields/GenerateFields';
import { CommonFilterForm } from '@type/filters';
import { SEARCH_FORM_FILTERS_OBJECT } from '@components/features/filters/helpers/searchFiltersObject';
import { mapSearchFilterToGlobalFilter } from '@components/features/filters/helpers/mapSearchFilterToGlobalFilter';
import { filterStyles } from '@components/features/filters/helpers/filterStyles';

const remoteFilterObject = mapSearchFilterToGlobalFilter(SEARCH_FORM_FILTERS_OBJECT.remote, 'checkbox');

/**
 * @description Generates the fields for the Remote filter.
 * * **recordFunc** - the 'record' function from useBjForm.
 * * **submitFunc** - the function to trigger the form submit. You might want to trigger it on blur. Defaults to undefined.
 * * **verticalSpacing** - the spacing between the items. Defaults to 'my-1.5'.
 * * **idPrefix** - the prefix for the form elements ids. When using multiple forms on the same page,
 * this is needed to avoid duplicate ids.
 */
export const JobSearchRemoteForm = (props: CommonFilterForm) => {
  // Destructure props
  const {
    recordFunc,
    submitFunc,
    verticalSpacing = filterStyles.formFieldSpacing,
    idPrefix,
  } = props;

  // Render component
  return (
    <GenerateFields
      recordFunc={recordFunc}
      submitFunc={submitFunc}
      filterObject={remoteFilterObject}
      idPrefix={idPrefix}
      spacing={verticalSpacing}
      labelStyles={`${filterStyles.formFieldLabel} font-bold`}
      inputStyles={filterStyles.formFieldInput}
    />
  );
};
